export default __webpack_public_path__ + "static/media/rastech-with-type.b8fc928a.png";